import * as React from 'react';
import Container from '@mui/material/Container';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import Tap151Link from 'components/WelcomeParty/Tap151Link.tsx'
import Tap151MapLink from 'components/WelcomeParty/Tap151MapLink.tsx'


export default function RehearsalDinnerDetails() {
  return (
    <Container sx={{
      display: 'flex',
      width: '100%',
      m: 0,
      p: 0,
    }}>
      <List sx={{ width: '100%' }}>
        <ListItem alignItems="flex-start">
          <ListItemText
            primary={
              <React.Fragment>
                <Typography variant="body2" component="span">
                  Join us at <Tap151Link underline='always' /> for dinner preceding the <Link href="/details">Welcome Party</Link>.
                <p>
                  We will eat, drink and offer the opportunity for any additional toasts that otherwise won't fit into the packed reception schedule.
                </p>
                <p>
                  Located in the heart of our home neighborhood "Cambridge Crossing", it is next to the Green Line T-Stop "Lechemere" and a short 15 minute walk from the Kimpton Marlowe. 
                </p>
                <p>Parking: <br/>

                </p>
                </Typography>
              </React.Fragment>
            }
          />
        </ListItem>
        <Divider component="li" />
        <ListItem alignItems="flex-start">
          <ListItemText
            slots={{secondary: 'div'}}
            primary={
              <React.Fragment>
                <Typography 
                  variant="body1" 
                  component="span"
                  sx={{
                    fontWeight: "bold"
                  }}
                >
                  Location
                </Typography>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                <Typography component="span" sx={{fontSize: 16, fontWeight: "bold"}}><Tap151Link underline='always' /></Typography>
                <Typography variant="body2"><Tap151MapLink /></Typography>
              </React.Fragment>
            }
          />
        </ListItem>
        <ListItem alignItems="flex-start">
          <ListItemText
            primary={
              <React.Fragment>
                <Typography 
                  variant="body1" 
                  component="span"
                  sx={{
                    fontWeight: "bold"
                  }}
                >
                  Dress Code
                </Typography>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                <Typography variant="body2" component="span">Smart-Casual</Typography>
              </React.Fragment>
            }
          />
        </ListItem>
      </List>
    </Container>
  );
}
